<template>
  <div class="r_h_100">
    <div class="r_h_100" v-if="$store.state.right_info.data === null || !order_loaded">
      <loadingCube :loadingMessage="'ORDER'"></loadingCube>
    </div>
    <div v-else id="order_right_info">
      <div id="ri_w_top">
        <button class="btn orcaBtn grey_bg" id="right_info_close" data-toggle="tooltip" title="Close information" @click="close_right_info">
          <i class="fas fa-times"></i> &nbsp;CLOSE
        </button>
        <div class="quick_btns">
          <button @click="show_order" class="btn orcaBtn greenBtn mb-2 ml-1" data-toggle="tooltip" title="View Order"><i class="fas fa-clipboard-list"></i></button>
          <button @click="show_company_record" class="btn orcaBtn purpleBtn mb-2 ml-1" data-toggle="tooltip" title="Go to Client Record">
            <i class="fas fa-store-alt"></i>
          </button>
          <a class="btn orcaBtn grey_bg mb-2 ml-1" data-toggle="tooltip" title="View Order Online"
          :href="web_url + 'company/order?id=' + $store.state.right_info.data.order_id" target="_blank"><i class="fas fa-globe"></i></a>
          <button @click="copy_order" class="btn orcaBtn sm_btn indigoBtn mb-2 ml-4" data-toggle="tooltip" title="Copy Order">
            <i class="fas fa-copy"></i>
          </button>
          <button v-if="$store.state.right_info.data.order_progress_status !== 'Ended'" @click="end_order" class="btn orcaBtn sm_btn warning mb-2 mr-1 ml-1"
                  data-toggle="tooltip" title="End Order">
            <i class="fas fa-stop"></i>
          </button>
        </div>

        <hr class="mt-1 mb-2">
        <div>
          <div class="d-inline-block" style="width: 280px">
            <h2 class="font-weight-bold bp_color mb-0 d-inline-block">{{ $store.state.right_info.data.order_ref }}</h2>
            <h5 class="mb-0">{{ $store.state.right_info.data.company_name }}</h5>
          </div>

          <div class="order_signed_box" :class="[$store.state.right_info.data.order_signed ? 'signed' : 'not_signed']">
            <div class="d-flex flex-row justify-content-center align-items-center" style="height: 100%;">
              <span v-if="$store.state.right_info.data.order_signed" class="order_signed">SIGNED</span>
              <span v-if="!$store.state.right_info.data.order_signed" class="order_not_signed">NOT SIGNED</span>
            </div>
          </div>
          <div v-if="!$store.state.right_info.data.order_signed" class="order_signed_box signed" style="cursor: pointer;" @click="resendOrder()">
            <div class="d-flex flex-row justify-content-center align-items-center" style="height: 100%;">
              <span v-if="!resending" class="order_signed"><i class="fas fa-envelope"></i> RE-SEND</span>
              <span v-if="resending" class="order_signed">Sending...</span>
            </div>
          </div>
        </div>
        <p class="b3_color mb-2"><strong>Consultant:</strong>&nbsp;&nbsp; {{ $store.state.right_info.data.consultant_name }}</p>
        <h4 class="bp_color mb-0">{{ $store.state.right_info.data.job_title }}</h4>
        <p class="mb-0">{{ $store.state.right_info.data.job_address_full }}</p>

        <hr class="mt-2 mb-2">
      </div>
      <div class="ri_w_after_top">
        <div class="row">
          <div class="col-xl-5 font-weight-bold">Order Status:</div>
          <div class="col-xl-7">{{ $store.state.right_info.data.order_progress_status }}</div>
          <div class="col-xl-5 font-weight-bold">Order Duration:</div>
          <div class="col-xl-7">{{ $store.state.right_info.data.start_date | formatDate }} -
            {{ $store.state.right_info.data.end_date | formatDate }}
          </div>
          <div class="col-12" v-if="check_expiring !== ''">
            <div class="expiry_warning" v-if="check_expiring === 'expiring'">Expiring within 2 weeks</div>
            <div class="expired" v-if="check_expiring === 'expired'">expired</div>
          </div>
          <div class="col-12">
            <hr class="mb-2 mt-2">
          </div>
          <div class="col-xl-5 font-weight-bold">Workers Required:</div>
          <div class="col-xl-7">{{ $store.state.right_info.data.workers_required }}</div>
          <div class="col-xl-5 font-weight-bold">Assigned Workers:</div>
          <div class="col-xl-7">{{ count_of_assigned }}</div>

          <div v-if="check_expiring !== 'expired'" :class="[(check_expiring !== 'expired' && count_of_assigned < $store.state.right_info.data.workers_required
          && $store.state.right_info.data.order_signed === 1) ? 'col-xl-6' : 'col-12']">
            <button @click.prevent="view_assigned_to_order" class="btn orcaBtn sm_btn greenBtn w-100 mt-2">View Assigned</button>
          </div>
          <div class="col-xl-6" v-if="check_expiring !== 'expired' && count_of_assigned < $store.state.right_info.data.workers_required
          && $store.state.right_info.data.order_signed === 1">
            <button @click.prevent="assign_worker" class="btn orcaBtn sm_btn w-100 mt-2">New Assignment</button>
          </div>
          <div class="col-12">
            <hr class="mb-2 mt-2">
          </div>
        </div>
        <!-- CONTACTS -->
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="bp_color">Contacts</h5>
            </div>
            <div class="col-12 mb-2">
              <div class="ind_contact">
                <h5 class="contact_header">JOB</h5>
                <div class="ind_contact_details">
                  <p class="mb-0 pl-2"><span style="font-weight: bold; font-size: 0.8rem;" v-if="Object.keys(order_contacts).length > 0">
                       {{ order_contacts.job_contact.person.first_name }} {{ order_contacts.job_contact.person.surname }}
                     </span></p>
                  <p class="mb-0 pl-2" style="line-height: 15px;">
                     <span v-if="order_contacts.job_contact.work_landline !== null"><i class="fas fa-phone-alt bp_color"></i>&nbsp;
                      {{ order_contacts.job_contact.work_landline }}&nbsp;&nbsp;</span>
                    <span v-if="order_contacts.job_contact.work_mobile !== null"><i class="fas fa-mobile-alt bp_color"></i>&nbsp;
                      {{ order_contacts.job_contact.work_mobile }}</span>
                  </p>
                  <p class="mb-0 pl-2" style="line-height: 15px;"><i class="fas fa-at bp_color"></i>&nbsp; {{ order_contacts.job_contact.work_email }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="ind_contact">
                <h5 class="contact_header">REP TO</h5>
                <div class="ind_contact_details">
                  <p class="mb-0 pl-2">
                    <span style="font-weight: bold; font-size: 0.8rem;" v-if="Object.keys(order_contacts).length > 0">
                    {{ order_contacts.reports_to_contact.person.first_name }} {{ order_contacts.reports_to_contact.person.surname }}
                    </span>
                  </p>
                  <p class="mb-0 pl-2" style="line-height: 15px;">
                    <span v-if="order_contacts.reports_to_contact.work_landline !== null"><i class="fas fa-phone-alt bp_color"></i>&nbsp;
                      {{ order_contacts.reports_to_contact.work_landline }}&nbsp;&nbsp;</span>
                    <span v-if="order_contacts.reports_to_contact.work_mobile !== null"><i class="fas fa-mobile-alt bp_color"></i>&nbsp;
                      {{ order_contacts.reports_to_contact.work_mobile }}</span>
                  </p>
                  <p class="mb-0 pl-2" style="line-height: 15px;">
                    <i class="fas fa-at bp_color"></i>&nbsp;{{ order_contacts.reports_to_contact.work_email }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr class="mb-3 mt-2">
          </div>
        </div>
        <!-- RATES -->
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="bp_color">Rates</h5>
            </div>
            <button @click="add_job_rates_modal" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="Add Rate to Order">
              <i class="fas fa-pound-sign"></i> &nbsp; Add Rate
            </button>
            <div class="col-12 mt-2">
              <div v-for="(r, i) in position_rates">
                <h5 class="mb-0">Rate {{i + 1}}</h5>
                <div class="row">
                  <div class="col-6">
                    <strong>{{ r.rate_type }} Rate</strong><br>{{ r.pay_amount | currency }} ({{ r.pay_type }})
                  </div>
                  <div class="col-6">
                    <strong><span v-if="crmType === 'payroll'">Admin Fee</span><span v-if="crmType === 'recruitment'">Charge Rate</span></strong><br>
                    <span v-if="r.admin_fee_type === '£ (Pound)'">{{ r.admin_fee_amount | currency }}</span>
                    <span v-if="r.admin_fee_type === '% (Percentage)'">{{ r.admin_fee_amount | percentage }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr class="mb-3 mt-2">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import loadingCube from "loaders/right_loader";

export default {
  name: "orders",
  components: {
    loadingCube
  },
  data() {
    return {
      web_url: process.env.MIX_WEBSITE_URL,

      order_loaded: false,

      position_rates: [],
      order_type: '',
      recruitment_margin_perc: 0,

      order_contacts: {},

      notes_loaded: false,
      notes: [],

      files_loaded: false,
      files: {},
      files_uploaded: [],
      file_order: [],

      activity_loaded: false,
      activity: {},
      resending: false
    }
  },
  computed: {
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    file_reload() {
      return this.$store.state.files.reload_files;
    },
    activity_reload() {
      return this.$store.state.logs.reload_logs;
    },
    rates_reload() {
      return this.$store.state.order_rates.reload_job_rates;
    },
    check_expiring() {
      let end_date = this.$moment(this.$store.state.right_info.data.end_date).utc();
      let end_date_14_days_before = this.$moment(this.$store.state.right_info.data.end_date).utc().subtract(14, 'days');
      let status = this.$store.state.right_info.data.order_progress_status;
      // is after end date
      if (this.$moment().utc().isAfter(end_date) || status === 'Ended') {
        return 'expired'
      }
      else if (this.$moment().utc().isAfter(end_date_14_days_before)) {
        return 'expiring'
      }
      else {
        return ''
      }
    },
    count_of_assigned() {
      if (this.$store.state.right_info.data.assignment_count !== undefined && this.$store.state.right_info.data.assignment_count !== null){
        return this.$store.state.right_info.data.assignment_count
      }

      if (this.$store.state.right_info.data?.rel_assignments?.length > 0) {
        let temp = this.$store.state.right_info.data.rel_assignments.filter(obj => obj.assigned === true)
        return temp.length;
      }
      else {
        return 0;
      }
    }
  },
  beforeMount() {
    this.get_order_info().then(() => this.order_loaded = true);

    this.$bus.$on('order_rates::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_JOB_RATES', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_JOB_RATES', {action: false}));
      }
    });
  },
  watch: {
    note_reload(val) {
      if (val) {
        this.notes_loaded = false;
        this.get_order_notes();
      }
    },
    file_reload(val) {
      if (val) {
        this.files_loaded = false;
        this.files_uploaded = [];
        this.get_order_files()
      }
    },
    activity_reload(val) {
      if (val) {
        this.activity_loaded = false;
        this.get_order_logs()
      }
    },
    rates_reload(val) {
      if (val) {
        this.get_order_rates();
      }
    }
  },
  methods: {
    ...mapActions(['hideRightInfo']),

    /*
     * GET RIGHT INFORMATION
     */
    get_order_info() {
      return new Promise(resolve => {
        this.get_order_rates().then(() => {
          this.get_order_contacts().then(() => {
            resolve();
          })
        })
      });
    },
    get_order_rates() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'order/position_rate/get/' + this.$store.state.right_info.data.id).then(rates => {
          // console.log(rates.data)
          this.position_rates = rates.data.rates;
          this.order_type = rates.data.order[0].order_type;
          this.recruitment_margin_perc = rates.data.position.recruitment_margin_perc
          resolve();
        })
      });
    },
    get_order_contacts() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'order/job/get_contacts/' + this.$store.state.right_info.data.id).then(contacts => {
          this.order_contacts = contacts.data;
          resolve();
        });
      });
    },
    get_order_notes() {
      return new Promise(resolve => {
        // axios.get(this.crmApiPath + 'order_notes/order/last_3/' + this.$store.state.right_info.data.id).then(order_notes => {
        //   this.notes = order_notes.data;
        //   this.notes_loaded = true;
          resolve();
        // }).catch(error => console.log(error.response));
      });
    },
    get_order_files() {
      return new Promise(resolve => {
        // TODO -- need file model/controller/migration + routes

        // axios.get(this.crmApiPath + 'order_files/order/last_3/' +this.$store.state.right_info.right_info.data.id).then(order_files => {
        //  this.files = order_files.data;
        //  this.$nextTick(() => order_files.data.forEach(file => this.files_uploaded.push(file.type)));
        // });
        resolve();
      });
    },

    get_order_logs() {
      return new Promise(resolve => {
        // axios.get(this.crmApiPath + 'order_logs/order/last_5/' + this.$store.state.right_info.data.id).then(order_logs => {
        //   this.activity = order_logs.data;
        //   this.activity_loaded = true;
          resolve();
        // });
      });
    },

    /*
     * QUICK ACTIONS
     */
    close_right_info() {
      this.hideRightInfo();
      this.$store.commit('CLEAR_RIGHT_INFO_TABLE_ROW');
    },
    show_order() {
      this.$store.commit('CURRENT_ORDER_ID', this.$store.state.right_info.data.id);
      this.$store.commit('SET_ORDER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/order/view');
        this.$tabs.refresh('/order/view', true)
      });
    },
    show_company_record() {
      this.$store.commit('CURRENT_RECORD_COMPANY_ID', this.$store.state.right_info.data.company_id);
      this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/company/record');
        this.$tabs.refresh('/company/record', true)
      });
    },
    copy_order() {
      this.$store.commit('COPY_ORDER_JOB_ID', this.$store.state.right_info.data.id);
      this.$nextTick(() => {
        this.close_right_info();
        this.$router.push('/order/copy');
        this.$tabs.refresh('/order/copy', true)
      });
    },
    resendOrder() {

        if(this.resending) {
          this.$snotify.warning('Email is already sending. Please wait.');
          return;
        }

        this.resending = true;
        let id = this.$store.state.right_info.data.order_id;

        if(Object.keys(this.order_contacts).length === 0) {
            this.$snotify.error('No JOB contact to send the order');
        }

        let payload = {
            order_id           : id,
            status             : 'Live',
            consultant_name    : this.$store.state.right_info.data.consultant_name,
            contact_first_name : this.order_contacts.job_contact.person.first_name,
            contact_surname    : this.order_contacts.job_contact.person.surname,
            contact_email      : this.order_contacts.job_contact.work_email
        };

        axios.post(this.crmApiPath + 'order/send_order_email', payload).then(() => {
          this.$snotify.success('Order has been sent to the client');
          this.resending = false;
        });
    },
    end_order() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Ending this Order!</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you want to<br><strong class="red_color">Unassign All Workers</strong><br>and<br><strong class="red_color">End '
            + this.$store.state.right_info.data.order_ref +
            '</strong>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'End Order', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.$snotify.confirm('', '', {
                closeOnClick: false,
                position: 'centerCenter',
                backdrop: 0.5,
                html: '<div class="snotifyToast__title">Are you sure!</div>' +
                    '<div class="snotifyToast__body">' +
                    '<strong class="text-uppercase">This cannot be undone.</strong><br>Are you sure you want to<br><strong class="red_color">Unassign All Workers</strong><br>and' +
                    '<br><strong class="red_color">End ' + this.$store.state.right_info.data.order_ref + '</strong>' +
                    '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                    '</div>',
                buttons: [
                  {
                    text: 'Confirm End Order', action: (toast) => {
                      axios.post(this.crmApiPath + 'order/job/end_and_unassign/' + this.$store.state.right_info.data.id, {
                        'log_by_id': this.$store.state.auth.me.id,
                        order_progress: {
                          'order_job_id': this.$store.state.right_info.data.id,
                          'order_progress_status': 'Ended'
                        },
                        assignments: {
                          'order_job_id': this.$store.state.right_info.data.id
                        }
                      }).then(res => {
                        this.close_right_info();
                        this.$snotify.remove(toast.id);
                      })
                    }
                  },
                  {text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)}
                ]
              })
            }
          },
          {text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      })
    },

    view_assigned_to_order() {
      this.$store.commit('CURRENT_ORDER_ID', this.$store.state.right_info.data.id);
      this.$store.commit('SET_ORDER_TAB_INDEX', 1);
      this.$nextTick(() => {
        this.$router.push('/order/view');
        this.$tabs.refresh('/order/view', true)
      });
    },

    assign_worker() {
      this.$store.commit('SET_ORDER_ASSIGNMENT', {
        company_id: this.$store.state.right_info.data.company_id,
        order_job_id: this.$store.state.right_info.data.id,
      })
      this.$nextTick(() => {
        this.$router.push('/orders/assignment');
        this.$tabs.refresh('/orders/assignment', true)
      });
    },

    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.$store.state.right_info.data.id,
        name: this.$store.state.right_info.data.order_ref,
        type: 'order',
        contacts: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    view_note_modal(note_id) {
      this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
        id: note_id,
        name: this.$store.state.right_info.data.order_ref,
        type: 'order',
        contacts: null
      });
      this.$store.state.notes.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
    },

    add_job_rates_modal() {
      this.$store.commit('SHOW_ADD_JOB_RATE_MODAL', {
        current_order_job_id: this.$store.state.right_info.data.id,
        current_rates: this.position_rates,
        order_type: this.order_type,
        recruitment_margin_perc: this.recruitment_margin_perc,
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_job_rate_modal'));
    }
  }
}
</script>

<style scoped lang="scss">
.r_h_100 {
  height: calc(100vh - 43px);
}

.sm_btn {
  display:     inline-block;
  width:       auto;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}

.expiry_warning, .expired {
  line-height:    30px;
  text-align:     center;
  color:          $white;
  margin-top:     10px;
  border-radius:  $border-radius;
  font-weight:    bold;
  text-transform: uppercase;
}

.expiry_warning {
  background: $orange;
}

.expired {
  background: $red;
}

#order_right_info {
  width:       $right_info_width;
  padding-top: 0;

  .row {
    margin-right: 0;
    margin-left:  0;

    &.extra_neg_margin {
      margin-right: -10px;
      margin-left:  -10px;
    }
  }

  #ri_w_top {
    position:         fixed;
    height:           210px;
    background-color: $right_info_bg;
    right:            0;
    width:            400px;
    padding:          10px 20px 10px 10px;
    z-index:          9;

    .order_signed_box {
      width:         80px;
      height:        45px;
      display:       inline-block;
      float:         right;
      text-align:    center;
      border-radius: $border-radius;

      &.signed {
        background: $green;
      }

      &.not_signed {
        background: $red;
      }
    }

    .order_signed, .order_not_signed {
      display:     inline-block;
      color:       $white;
      font-weight: bold;
      font-size: 0.65rem;
    }
  }

  .ri_w_after_top {
    padding-top:    210px;
    width:          100%;
    padding-bottom: 20px;
    padding-right:  20px;

    .ind_contact {
      position:       relative;
      display:        block;
      border-radius:  $border_radius_2;
      padding-top:    2px;
      padding-bottom: 5px;
      border:         solid 2px $bc_3;
      border-left:    20px $bc_3 solid;

      .contact_header {
        font-weight:      bold;
        font-size:        0.68rem;
        color:            $white;
        text-transform:   uppercase;
        position:         absolute;
        top:              7px;
        right:            0;
        left:             -4px;
        margin-bottom:    0;
        transform-origin: top left;
        transform:        rotate(90deg);
        height:           15px;
        width:            50px;
      }

      .ind_contact_details {
        width: 320px;
      }

      .contact_label {
        display: inline-block;
        width:   65px;
      }
    }
  }

  .quick_btns, .quick_action_btns {
    .orcaBtn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
    }
  }

  .ri_w_section {
    display:  block;
    position: relative;

    .sm-btn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
      float:       right;
    }

    .top_right_btn {
      position: absolute;
      right:    5px;
      top:      -5px;
    }

    .ri_w_label {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
    }

    .ri_w_no_content {
      background:     $red;
      padding-top:    5px;
      padding-bottom: 5px;

      .ri_w_label {
        color: $white;
      }
    }

    .ri_w_loading {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
      font-size:     1rem;
    }

    .latest_entity_test {
      margin-bottom: 0;

      &.Fail, &.Amber {
        color:          $white;
        padding-top:    5px;
        padding-bottom: 5px;
      }

      &.Fail {
        background: $red;
      }

      &.Amber {
        background: $orange;
      }

      &.Pass {
        .test_status {
          color: $green;
        }
      }

      button {
        float:          none;
        vertical-align: middle;
        margin-right:   10px;
      }

      .test_status {
        width:          70px;
        display:        inline-block;
        vertical-align: middle;
        line-height:    1.1;
        font-weight:    bold;
        font-size:      1rem;
        text-transform: uppercase;
      }

      .test_info {
        width:          calc(100% - 130px);
        display:        inline-block;
        vertical-align: middle;

        .test_date, .test_created_at {
          line-height: 1.1;
          display:     block;
          font-size:   0.625rem;
        }

        .test_date {
          font-weight: bold;
        }

        .test_created_at {
          margin-top: 3px;
        }
      }
    }

    #contacts_box {
      max-height: 200px;
      overflow-y: scroll;
    }

    .all_contacts {
      margin-top: 5px;
      background: lighten($bc_5, 12.5%);
      padding:    7.5px;

      .contact_details {
        width:          calc(100% - 56px);
        /*width:          100%;*/
        display:        inline-block;
        vertical-align: middle;

      }

      .contact_name, .contact_job_title {
        line-height: 1.1;
        display:     block;
      }

      .contact_name {
        font-weight: bold;
        font-size:   0.9rem;
      }

      .contact_job_title {
        margin-top:    3px;
        margin-bottom: 3px;
      }

      .contact_pm {
        display: inline-block;
        width:   47.5%;
      }

      .contact_e {
        display: block;
        width:   100%;
      }

      .contact_pm, .contact_e {
        i {
          color:        $bc_1;
          margin-right: 5px;
        }
      }
    }

    .last_notes {
      margin-bottom: 15px;

      button {
        float:          none;
        vertical-align: middle;
        margin-right:   10px;
      }

      .note_details {
        width:          calc(100% - 56px);
        display:        inline-block;
        vertical-align: middle
      }

      .note_on, .note_type, .note_title, .note_user_created_at {
        line-height: 1.1;
        display:     block;
      }

      .note_on {
        font-weight: bold;
        color:       $bc_1;
      }

      .note_type {
        font-weight: bold;
        font-size:   0.9rem;
      }

      .note_title {
        margin-top: 3px;
      }

      .note_user_created_at {
        font-size:  0.625rem;
        margin-top: 3px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .last_activity {
      margin-bottom: 3px;
      border:        none;
      background:    transparent;
      padding:       5px 5px 7px 5px;
      display:       block;
      width:         100%;
      text-align:    left;

      &:focus {
        outline: none;
      }

      .log_type {
        display:     block;
        font-weight: bold;

        .log_icon {
          font-size:      0.65rem;
          display:        inline-block;
          margin-right:   10px;
          border:         2px solid;
          border-radius:  50%;
          text-align:     center;
          height:         20px;
          width:          20px;
          line-height:    17px;
          vertical-align: top;
        }

        .log_type_info {
          display:     inline-block;
          width:       calc(100% - 35px);
          line-height: 1.2;
        }
      }

      .log_user_created_at {
        font-size:   0.65rem;
        line-height: 10px;
        height:      10px;
        display:     block;
        margin-left: 34px;
      }

      &.created, &.updated, &.restored, &.deleted {
        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          color:         $white;
          border-radius: $border-radius_2;
        }
      }

      &.created {
        color:        $green;
        border-color: $green;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $green;
        }
      }

      &.updated {
        color:        $blue;
        border-color: $blue;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $blue;
        }
      }

      &.restored {
        color:        $orange;
        border-color: $orange;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $orange;
        }
      }

      &.deleted {
        color:        $red;
        border-color: $red;

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background: $red;
        }
      }
    }
  }
}

</style>
